import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Tooltip, Tag } from "antd";
import { useState } from "react";
import { RoleCreationForm } from "../../Drawers/RolesCreation";
import { API_URL } from "../../../API/Config";
import ReTable from "../../../unity-ui-common/Components/ReTable/ReTable";
import * as Styles from "./ManageRolesStyles";

function ManageRoles() {
  const [selectedTableRow, setSelectedTableRow] = useState<string[]>([]);
  const [currEditingRole, setCurrEditingRole] = useState({});
  const [roleDrawerVisibility, setRoleDrawerVisibility] =
    useState<boolean>(false);
  const [roleDrawerType, setRoleDrawerType] = useState<string>("");

  const columns = [
    {
      title: "",
      width: 50,
      key: "edit",
      dataIndex: "edit",
      hideInCustomizeView: true,
      render: (text: any, record: any) => {
        return (
          <>
            {selectedTableRow.length !== 0 ? (
              ""
            ) : (
              <Tooltip title="Edit">
                <EditOutlined
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    setCurrEditingRole(record);

                    setRoleDrawerType("edit");
                    setRoleDrawerVisibility(true);
                  }}
                />
              </Tooltip>
            )}
          </>
        );
      },
    },
    {
      title: "Role",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Privileges ",
      dataIndex: "permissions",
      render: (permissions: any) => {
        return (
          <div>
            {permissions.map((per: any) => {
              return <Tag key={per.id}>{per.name}</Tag>;
            })}
          </div>
        );
      },
    },
  ];

  return (
    <Styles.Container>
      <RoleCreationForm
        drawerType={roleDrawerType}
        visibility={roleDrawerVisibility}
        setRoleDrawerType={setRoleDrawerType}
        setRoleDrawerVisibility={setRoleDrawerVisibility}
        currEditingRole={currEditingRole}
      />
      <ReTable
        name="All Roles"
        title="All Roles"
        columns={columns}
        refresh={roleDrawerVisibility}
        columnOptions={{
          sorting: {
            columns: ["name"],
          },
          filter: {
            filterSearch: true,
            columns: ["name"],
          },
        }}
        scroll={{
          x: 800,
          y: 500,
        }}
        rowSelection={{
          selectedRowKeys: selectedTableRow,
          type: "checkbox",
          setSelectedRowKeys: setSelectedTableRow,
          rowKey: "id",
        }}
        uniView={{
          uniView: "role",
          viewName: "allRoles",
          apiUrl: API_URL,
          option: {
            orderBy: {
              key: "name",
              order: "ASC",
            },
            limit: 10,
          },
        }}
        exportOption={{
          csv: {},
        }}
        headerButtons={[
          {
            title: "Add New",
            icon: <PlusOutlined />,
            onClick: () => {
              setRoleDrawerType("create");
              setRoleDrawerVisibility(true);
            },
          },
        ]}
      />
    </Styles.Container>
  );
}

export default ManageRoles;
